(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  var sortSelect = document.getElementById('collection-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var content = item.querySelector('.faq-content');
        var chevron = item.querySelector('.faq-chevron');
        var isOpen = content.classList.contains('is-open');

        var section = btn.closest('[id^="faq-"]');
        section.querySelectorAll('.faq-content.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          var sib = el.closest('.faq-item');
          sib.querySelector('.faq-chevron').classList.remove('is-open');
          sib.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          content.classList.add('is-open');
          chevron.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[id^="HomepageReviews-"]');
    if (!section) return;

    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');

    if (!track) return;

    function getScrollAmount() {
      var card = track.querySelector('.homepage-reviews__card');
      return card ? card.offsetWidth + 16 : 340;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Scroll to top after form submission instead of anchor
    if (window.location.hash.indexOf('contact_form') !== -1) {
      window.scrollTo(0, 0);
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    // Prefill message from product query param
    var params = new URLSearchParams(window.location.search);
    var productName = params.get('product');
    if (!productName) return;

    var textarea = document.getElementById('ContactBody');
    if (!textarea || textarea.value.trim() !== '') return;

    var template = textarea.getAttribute('data-inquiry-template');
    if (!template) return;

    textarea.value = template.replace('_PRODUCT_', productName);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-main"]) return;
  try {
    
  (function() {
    var toc = document.querySelector('[data-page-toc]');
    if (!toc) return;

    var container = toc.closest('[data-page-section]');
    var prose = container && container.querySelector('.prose');
    var list = toc.querySelector('[data-page-toc-list]');

    if (!prose || !list) return;

    var headings = prose.querySelectorAll('h2, h3');
    if (headings.length < 2) return;

    var baseCls = 'block py-1 no-underline border-l-2 border-transparent -ml-px transition-colors text-foreground/60 hover:text-foreground aria-[current=true]:text-foreground aria-[current=true]:border-foreground';
    var h2Cls = baseCls + ' pl-3 text-xs leading-snug';
    var h3Cls = baseCls + ' pl-6 text-xs leading-snug';

    var fragment = document.createDocumentFragment();
    var slugCounts = {};

    headings.forEach(function(heading) {
      var text = heading.textContent.trim();
      var slug = text
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

      if (slugCounts[slug]) {
        slugCounts[slug]++;
        slug = slug + '-' + slugCounts[slug];
      } else {
        slugCounts[slug] = 1;
      }

      heading.id = slug;

      var li = document.createElement('li');
      li.className = 'm-0';

      var a = document.createElement('a');
      a.href = '#' + slug;
      a.textContent = text;
      a.className = heading.tagName === 'H3' ? h3Cls : h2Cls;
      a.addEventListener('click', function(e) {
        e.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + slug);
      });

      li.appendChild(a);
      fragment.appendChild(li);
    });

    list.appendChild(fragment);

    var links = list.querySelectorAll('a');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          links.forEach(function(link) {
            link.removeAttribute('aria-current');
          });
          var activeLink = list.querySelector('a[href="#' + CSS.escape(entry.target.id) + '"]');
          if (activeLink) {
            activeLink.setAttribute('aria-current', 'true');
          }
        }
      });
    }, {
      rootMargin: '-80px 0px -70% 0px',
      threshold: 0
    });

    headings.forEach(function(heading) {
      observer.observe(heading);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.product-reviews');
    if (!section) return;

    var formCol = section.querySelector('.product-reviews__form-col');
    var reviewsList = section.querySelector('.product-reviews__list');

    if (formCol && reviewsList) {
      function syncHeight() {
        reviewsList.style.maxHeight = '';
        var formHeight = formCol.offsetHeight;
        reviewsList.style.maxHeight = formHeight + 'px';
      }
      syncHeight();
      window.addEventListener('resize', syncHeight);
    }

    var starInputs = section.querySelectorAll('.product-reviews__star-input');
    var ratingHidden = document.getElementById('ReviewRatingValue');

    starInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        if (ratingHidden) {
          ratingHidden.value = this.value;
        }
      });
    });

    var form = section.querySelector('.product-reviews__form-col form');
    if (form) {
      form.addEventListener('submit', function() {
        var bodyField = document.getElementById('ReviewBody');
        var ratingValue = ratingHidden ? ratingHidden.value : '';
        var productTitle = section.dataset.productTitle || '';

        if (bodyField && ratingValue && productTitle) {
          var prefix = '[Review for ' + productTitle + '] [Rating: ' + ratingValue + '/5]\n\n';
          if (bodyField.value.indexOf('[Review for ') !== 0) {
            bodyField.value = prefix + bodyField.value;
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-product-section]');
    sections.forEach(function(sectionEl) {
      var sectionWrapper = sectionEl.closest('.shopify-section');
      if (!sectionWrapper) return;
      var sectionId = sectionWrapper.id.replace('shopify-section-', '');
      var dataEl = document.getElementById('ProductData-' + sectionId);
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants;
      var mainImageWrap = document.getElementById('ProductMainImage-' + sectionId);
      var priceWrap = document.getElementById('ProductPrice-' + sectionId);
      var thumbs = sectionEl.querySelectorAll('[data-thumb]');

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
          var imgUrl = thumb.getAttribute('data-image-url');
          var mainImg = mainImageWrap.querySelector('img');
          if (mainImg && imgUrl) {
            mainImg.src = imgUrl;
            mainImg.srcset = '';
          }
        });
      });

      var form = sectionEl.querySelector('[data-product-form]');
      if (!form) return;

      var variantInput = form.querySelector('[data-variant-id]');
      var addBtn = form.querySelector('[data-add-to-cart]');

      var qtyInput = form.querySelector('[data-qty-input]');
      var minusBtn = form.querySelector('[data-qty-minus]');
      var plusBtn = form.querySelector('[data-qty-plus]');

      if (minusBtn && plusBtn && qtyInput) {
        minusBtn.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) qtyInput.value = val - 1;
        });
        plusBtn.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = val + 1;
        });
      }

      var optionInputs = form.querySelectorAll('[data-option-value]');
      optionInputs.forEach(function(input) {
        input.addEventListener('change', function() {
          var selectedOptions = [];
          var fieldsets = form.querySelectorAll('[data-option-index]');
          fieldsets.forEach(function(fieldset) {
            var checked = fieldset.querySelector('[data-option-value]:checked');
            if (checked) selectedOptions.push(checked.value);
          });

          var matchedVariant = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var match = true;
            for (var j = 0; j < selectedOptions.length; j++) {
              if (v.options[j] !== selectedOptions[j]) {
                match = false;
                break;
              }
            }
            if (match) {
              matchedVariant = v;
              break;
            }
          }

          if (matchedVariant) {
            variantInput.value = matchedVariant.id;

            var url = new URL(window.location.href);
            url.searchParams.set('variant', matchedVariant.id);
            window.history.replaceState({}, '', url.toString());

            var priceHtml = '';
            if (matchedVariant.unit_price) {
              var upm = matchedVariant.unit_price_measurement;
              var refLabel = (upm.reference_value && upm.reference_value !== 1 ? upm.reference_value : '') + (upm.reference_unit || '');
              priceHtml += '<span class="text-2xl font-bold text-foreground" data-price>' + formatMoney(matchedVariant.unit_price, data.moneyFormat) + ' / ' + refLabel + '</span>';
            } else if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
              var savings = matchedVariant.compare_at_price - matchedVariant.price;
              priceHtml += '<s class="text-base text-muted" data-compare-price>' + formatMoney(matchedVariant.compare_at_price, data.moneyFormat) + '</s>';
              priceHtml += '<span class="text-2xl font-bold text-foreground" data-price>' + formatMoney(matchedVariant.price, data.moneyFormat) + '</span>';
              priceHtml += '<span class="badge badge-sm badge-subtle" data-savings>' + data.save + ' ' + formatMoney(savings, data.moneyFormat) + '</span>';
            } else {
              priceHtml += '<span class="text-2xl font-bold text-foreground" data-price>' + formatMoney(matchedVariant.price, data.moneyFormat) + '</span>';
            }
            priceWrap.innerHTML = priceHtml;

            if (matchedVariant.available) {
              addBtn.disabled = false;
              addBtn.textContent = data.addToCart;
            } else {
              addBtn.disabled = true;
              addBtn.textContent = data.soldOut;
            }

            if (matchedVariant.featured_image) {
              var mainImg = mainImageWrap.querySelector('img');
              if (mainImg) {
                mainImg.src = matchedVariant.featured_image.src;
                mainImg.srcset = '';
              }
              thumbs.forEach(function(t) {
                t.classList.remove('is-active');
                if (t.getAttribute('data-media-id') == matchedVariant.featured_media.id) {
                  t.classList.add('is-active');
                }
              });
            }
          }
        });
      });

      var drawerSection = document.querySelector('cart-drawer-component');
      var cartSectionId = drawerSection
        ? drawerSection.closest('.shopify-section').id.replace('shopify-section-', '')
        : '';

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        addBtn.disabled = true;

        var formData = new FormData(form);
        formData.append('sections', cartSectionId);
        formData.append('sections_url', window.location.pathname);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then(function(res) { return res.json(); })
          .then(function(data) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                source: 'product-form',
                sections: data.sections,
              },
            }));
            addBtn.disabled = false;
          })
          .catch(function() {
            addBtn.disabled = false;
          });
      });

      function formatMoney(cents, format) {
        var amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*amount\s*\}\}/, amount)
                     .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                     .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
                     .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
